import React, { useEffect, useState } from 'react';
import { Row, Col, FormGroup, Label, Input, Button } from 'reactstrap';
import FileServer from 'file-saver';
import { axiosApi } from '../Basicos/axiosInstances';
import AnaliseVacinacao from './AnaliseVacinacao';
import { ROTULOS_SITUACAO, CORES_SITUACAO } from './vacinacaoConstantes';

const estiloCard = {
    border: '1px solid #e9ecef',
    borderRadius: '.5rem',
    boxShadow: '0 1px 3px rgba(0,0,0,.08)',
    padding: '.75rem 1rem',
};

export default function SituacaoVacinal() {
    const [campanhas, setCampanhas] = useState([]);
    const [campanhaId, setCampanhaId] = useState('');
    const [semestres, setSemestres] = useState([]);
    const [semestreId, setSemestreId] = useState('');
    const [turmas, setTurmas] = useState([]);
    const [turmaId, setTurmaId] = useState('');
    const [situacao, setSituacao] = useState('');

    const [documentos, setDocumentos] = useState([]);
    const [contadores, setContadores] = useState({});
    const [paginacao, setPaginacao] = useState({});
    const [carregando, setCarregando] = useState(false);

    const [analiseAberta, setAnaliseAberta] = useState(false);
    const [alunoSelecionado, setAlunoSelecionado] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await axiosApi.get('/vacinacao/campanha');
                setCampanhas(data.dados || []);
            } catch (error) {
                console.log(error);
            }
        })();

        (async () => {
            try {
                const { data } = await axiosApi.get('/vacinacao/semestres');
                setSemestres(data.dados || []);
            } catch (error) {
                console.log(error);
            }
        })();
    }, []);

    useEffect(() => {
        setTurmaId('');

        if (!campanhaId || !semestreId) {
            setTurmas([]);
            return;
        }

        (async () => {
            try {
                const { data } = await axiosApi.get('/vacinacao/turmas', {
                    params: { campanha_id: campanhaId, semestre_id: semestreId },
                });
                setTurmas(data.dados || []);
            } catch (error) {
                console.log(error);
            }
        })();
    }, [campanhaId, semestreId]);

    const filtros = () => ({
        campanha_id: campanhaId,
        semestre_id: semestreId || undefined,
        turma_id: turmaId || undefined,
        situacao: situacao || undefined,
    });

    const pesquisar = async (pagina = 1) => {
        if (!campanhaId) {
            return;
        }

        setCarregando(true);
        try {
            const { data } = await axiosApi.get('/vacinacao/situacao', {
                params: { ...filtros(), page: pagina },
            });
            setDocumentos(data.documentos);
            setContadores(data.contadores);
            setPaginacao(data.paginacao);
        } catch (error) {
            console.log(error);
        } finally {
            setCarregando(false);
        }
    };

    const limpar = () => {
        setSemestreId('');
        setTurmaId('');
        setSituacao('');
        setDocumentos([]);
        setContadores({});
        setPaginacao({});
    };

    const exportar = async () => {
        try {
            const { data } = await axiosApi.get('/vacinacao/situacao/exportar', {
                params: filtros(),
                responseType: 'blob',
            });
            FileServer.saveAs(new File([data], 'situacao-vacinal.xlsx', { type: data.type }));
        } catch (error) {
            console.log(error);
        }
    };

    const abrirAnalise = (linha) => setAlunoSelecionado(linha) || setAnaliseAberta(true);

    const fecharAnalise = (atualizado) => {
        setAnaliseAberta(false);
        setAlunoSelecionado(null);
        if (atualizado) {
            pesquisar(paginacao.pagina_atual || 1);
        }
    };

    if (analiseAberta) {
        return (
            <AnaliseVacinacao
                campanhaId={campanhaId}
                alunoId={alunoSelecionado?.aluno_id}
                onVoltar={fecharAnalise}
            />
        );
    }

    return (
        <Col sm={12} md={12} className="col-conteudo p-4">
            <Row form className="align-items-end mt-3">
                <Col xs={12} md={3}>
                    <FormGroup>
                        <Label>Campanha*</Label>
                        <Input type="select" value={campanhaId} onChange={(e) => setCampanhaId(e.target.value)}>
                            <option value="">Selecione...</option>
                            {campanhas.map((campanha) => (
                                <option key={campanha.id} value={campanha.id}>{campanha.descricao}</option>
                            ))}
                        </Input>
                    </FormGroup>
                </Col>
                <Col xs={12} sm={6} md={2}>
                    <FormGroup>
                        <Label>Semestre</Label>
                        <Input type="select" value={semestreId} onChange={(e) => setSemestreId(e.target.value)}>
                            <option value="">Todos</option>
                            {semestres.map((item) => (
                                <option key={item.id} value={item.id}>{item.descricao}</option>
                            ))}
                        </Input>
                    </FormGroup>
                </Col>
                <Col xs={12} sm={6} md={2}>
                    <FormGroup>
                        <Label>Turma</Label>
                        <Input
                            type="select"
                            value={turmaId}
                            onChange={(e) => setTurmaId(e.target.value)}
                            disabled={!semestreId}
                        >
                            <option value="">Todas</option>
                            {turmas.map((item) => (
                                <option key={item.value} value={item.value}>{item.label}</option>
                            ))}
                        </Input>
                    </FormGroup>
                </Col>
                <Col xs={12} sm={6} md={3}>
                    <FormGroup>
                        <Label>Situação</Label>
                        <Input type="select" value={situacao} onChange={(e) => setSituacao(e.target.value)}>
                            <option value="">Todas</option>
                            {Object.entries(ROTULOS_SITUACAO).map(([valor, rotulo]) => (
                                <option key={valor} value={valor}>{rotulo}</option>
                            ))}
                        </Input>
                    </FormGroup>
                </Col>
                <Col xs={12} sm={6} md={2}>
                    <FormGroup>
                        <Label>&nbsp;</Label>
                        <div className="d-flex align-items-center" style={{ height: 'calc(1.5em + .75rem)', gap: '.5rem' }}>
                            <Button className="flex-fill" color="primary" outline onClick={limpar}>Limpar</Button>
                            <Button className="flex-fill" color="primary" onClick={() => pesquisar(1)} disabled={!campanhaId || carregando}>Pesquisar</Button>
                        </div>
                    </FormGroup>
                </Col>
            </Row>
            {paginacao.total_registros !== undefined && (
                <>
                    <div className="d-flex justify-content-around mb-3 mt-3">
                        <div className="text-center" style={estiloCard}>
                            <div style={{ fontSize: '1.5rem', fontWeight: 700, color: CORES_SITUACAO.sem_envio }}>{contadores.sem_envio ?? 0}</div>
                            <div>Sem envio</div>
                        </div>
                        <div className="text-center" style={estiloCard}>
                            <div style={{ fontSize: '1.5rem', fontWeight: 700, color: CORES_SITUACAO.pendente_revisao_manual }}>{contadores.pendente_revisao_manual ?? 0}</div>
                            <div>Pendente de revisão</div>
                        </div>
                        <div className="text-center" style={estiloCard}>
                            <div style={{ fontSize: '1.5rem', fontWeight: 700, color: CORES_SITUACAO.conforme_automatico }}>{contadores.conforme_automatico ?? 0}</div>
                            <div>Conforme automático</div>
                        </div>
                        <div className="text-center" style={estiloCard}>
                            <div style={{ fontSize: '1.5rem', fontWeight: 700, color: CORES_SITUACAO.conforme_revisado }}>{contadores.conforme_revisado ?? 0}</div>
                            <div>Conforme revisado</div>
                        </div>
                        <div className="text-center" style={estiloCard}>
                            <div style={{ fontSize: '1.5rem', fontWeight: 700, color: CORES_SITUACAO.nao_conforme }}>{contadores.nao_conforme ?? 0}</div>
                            <div>Não conforme</div>
                        </div>
                    </div>

                    <table className="tabelaConsulta">
                        <thead>
                            <tr>
                                <th className="tabelaConsulta__celulaCabecalho">Matrícula</th>
                                <th className="tabelaConsulta__celulaCabecalho">Nome</th>
                                <th className="tabelaConsulta__celulaCabecalho">Semestre</th>
                                <th className="tabelaConsulta__celulaCabecalho">Grupo</th>
                                <th className="tabelaConsulta__celulaCabecalho">Aceitos</th>
                                <th className="tabelaConsulta__celulaCabecalho">Recusados</th>
                                <th className="tabelaConsulta__celulaCabecalho">Situação</th>
                                <th className="tabelaConsulta__celulaCabecalho">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {documentos.length === 0 ? (
                                <tr><td className="tabelaConsulta__celulaDados" colSpan={8}>Não há dados disponíveis</td></tr>
                            ) : documentos.map((linha) => (
                                <tr key={linha.aluno_id}>
                                    <td className="tabelaConsulta__celulaDados">{linha.matricula}</td>
                                    <td className="tabelaConsulta__celulaDados">{linha.nome}</td>
                                    <td className="tabelaConsulta__celulaDados">{linha.semestre}</td>
                                    <td className="tabelaConsulta__celulaDados">{linha.grupo}</td>
                                    <td className="tabelaConsulta__celulaDados">{linha.aceitos}</td>
                                    <td className="tabelaConsulta__celulaDados">{linha.recusados}</td>
                                    <td className="tabelaConsulta__celulaDados" style={{ color: CORES_SITUACAO[linha.situacao], fontWeight: 700 }}>
                                        {ROTULOS_SITUACAO[linha.situacao] || linha.situacao}
                                    </td>
                                    <td className="tabelaConsulta__celulaDados">
                                        <Button size="sm" color="link" className="font-weight-bold" onClick={() => abrirAnalise(linha)}>
                                            Analisar
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <div>
                            <Button size="sm" disabled={paginacao.pagina_atual <= 1} onClick={() => pesquisar(paginacao.pagina_atual - 1)}>«</Button>
                            {' '}Página {paginacao.pagina_atual} de {paginacao.total_paginas}{' '}
                            <Button size="sm" disabled={paginacao.pagina_atual >= paginacao.total_paginas} onClick={() => pesquisar(paginacao.pagina_atual + 1)}>»</Button>
                            {' '}— Registros: {documentos.length} de {paginacao.total_registros}
                        </div>
                        <Button color="primary" size="sm" onClick={exportar}>Exportar XLSX</Button>
                    </div>
                </>
            )}
        </Col>
    );
}
